<!-- 预收管理费 -->
<template>
	<div class='page_content'>
		<subComponents ref="showSelectData"></subComponents>
		<div class="page_content_top">
			<v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :showRefresh="true" :buttonFlag="false"></v-button>
			<div class="page_content_top_line">
				<el-form :inline="true" :model="getRequestData" class="demo-form-inline dis" size="mini" label-width="100px">
					<el-form-item label="货主名称">
                        <label slot="label" :style="$common.labelStyle('货主名称')" v-html="'货主名称'"></label>
						<el-input class="form_codition" clearable v-model="getRequestData.coName"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="mini" icon="el-icon-search" @click="searchData">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
				@selection-change="handleSelectionChange" highlight-current-row size="mini">
				<el-table-column type="selection" width="40">
				</el-table-column>
				<el-table-column prop="yearMonths" label="年-月" show-overflow-tooltip></el-table-column>
				<el-table-column prop="coCode" label="货主编码" show-overflow-tooltip></el-table-column>
				<el-table-column prop="coName" label="货主" show-overflow-tooltip></el-table-column>
				<el-table-column prop="totalManageExp" label="管理费用" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="settleTotalManageExp" label="实际结算费用" show-overflow-tooltip>
				</el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
				:current-page="getRequestData.page" :page-sizes="[30, 50, 100,500]" :page-size="30"
				layout="total, sizes, prev, pager, next, jumper" :total="returnData.total">
			</el-pagination>
		</div>
		<el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
			<SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData"
				@TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
		</el-dialog>
		<el-dialog title="修改费用" v-if="diaChangeMoney" :visible.sync="diaChangeMoney" width="400px">
			<el-form>
				<el-form-item label="结算费用">
					<el-input v-model="money" size="mini" type="number" @input="chekcMoney" :min="0" :max="select"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="diaChangeMoney = false">取 消</el-button>
				<el-button type="primary" @click="conChangeMoney">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="查看明细" v-if="diaLookMx" :visible.sync="diaLookMx" width="80%">
			<el-table size="mini" height="500" :data="mxData" border style="width:100%">
				<el-table-column prop="businessId" label="单号" show-overflow-tooltip min-width="100">
				</el-table-column>
				<el-table-column prop="businessType" label="订单类型" show-overflow-tooltip min-width="100">
				</el-table-column>
				<el-table-column prop="cmName" label="销售单位" show-overflow-tooltip min-width="100">
				</el-table-column>
				<el-table-column prop="coName" label="货主" show-overflow-tooltip min-width="100">
				</el-table-column>
				<!-- <el-table-column prop="depName" label="业务部门" show-overflow-tooltip min-width="100">
				</el-table-column> -->
				<el-table-column prop="opmName" label="业务员名称" show-overflow-tooltip min-width="100">
				</el-table-column>
				<el-table-column prop="salesName" label="对方业务员" show-overflow-tooltip min-width="100">
				</el-table-column>
				<el-table-column prop="totalNumber" label="总数量" show-overflow-tooltip min-width="100">
				</el-table-column>
				<el-table-column prop="oldMoney" label="总金额" show-overflow-tooltip min-width="100">
				</el-table-column>
				<el-table-column prop="manageExp" label="管理费用" show-overflow-tooltip min-width="100">
				</el-table-column>
				<!-- <el-table-column prop="manageFee" label="管理费用比例" show-overflow-tooltip min-width="100">
				</el-table-column> -->
			</el-table>
			<el-pagination background @size-change="setDataPageSize1" @current-change="setDataPageNumber1"
				:current-page="getRequestData1.page" :page-sizes="[30, 50, 100,500]" :page-size="30"
				layout="total, sizes, prev, pager, next, jumper" :total="returnData1.total">
			</el-pagination>
		</el-dialog>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Vue from "vue";
import SearchScheme from "@/byComponents/SearchScheme.vue";
import ExtractionScheme from "@/byComponents/ExtractionScheme.vue";
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {
		SearchScheme,
		ExtractionScheme,
	},
	data() {
		//这里存放数据
		return {
            tableHeight:0,
			getRequestData: {
				coName: "",
				page: 1,
				rows: 30
			},
			getRequestData1: {
				coName: "",
				page: 1,
				rows: 30,
			},
			returnData: {
				pages: 0, // 总页数
				total: 0, // 总条数
				pageNum: 0, // 当前页数
				list: [],
			},
			returnData1: {
				pages: 0, // 总页数
				total: 0, // 总条数
				pageNum: 0, // 当前页数
				list: [],
			},
			buttonList: [],
			pageShowData: [],
			formDataList: [],
			selectedDataIndex: 0,
			exId: "",
			seId: "",
			ceshi: "",
			dialogTitle: "",
			seWidth: "",
			height: "",
			exTitle: "",
			seTitle: "",
			seWidth: "",
			exWidth: "",
			DialogVisible: false,
			DialogExtract: false,
			seType: "",
			smId: "",
			isShowTooltip: false,
			showStatus: false,
			actionData: {},
			parentSearchData: {},
			sField: "",
			cateList: [],
			multipleSelection: [],
			diaChangeMoney: false,
			money: '',
			selectInfo: {},
			diaLookMx: false
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
	},
	//方法集合
	methods: {
		chekcMoney() {
			if (this.money <0) {
				this.money = 0
				this.$message({
					message: '请填写合理费用',
					type: 'warning'
				});
			}
			// else if (this.money >this.selectInfo.settleTotalManageExp) {
			// 	this.money = this.selectInfo.settleTotalManageExp
			// 	this.$message({
			// 		message: '请填写合理费用',
			// 		type: 'warning'
			// 	});
			// } 
			else if (this.money == '') {
				this.money = 0
			}
		},
		conChangeMoney() {
			this.returnData.list.forEach(item => {
				if (item.coId == this.selectInfo.coId && item.yearMonths == this.selectInfo.yearMonths) {
					item.settleTotalManageExp = this.money
					this.diaChangeMoney = false
				}
			})
		},
		checkSelect() {
			let flag = true
			if (this.returnData.list.length <= 0) {
				this.$message({
					message: '暂无数据',
					type: 'error'
				});
				flag = false
			} else if (this.multipleSelection.length <= 0) {
				this.$message({
					message: '请先选中要操作的数据',
					type: 'error'
				});
				flag = false
			}
			return flag
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		changeTime(val) {
			if (val) {
				var time = val + 24 * 60 * 60 * 1000 - 1;
				this.getRequestData.end = time;
			}
		},
		// 子组件触发
		drawerCancel(commitData) {
			this.showStatus = false
			commitData && this.getDataList()
		},
		// 点击穿透字段 传参单号
		toDetail(orderId) {
			if (orderId) {
				// 设置为true 打开穿透组件首页
				var isPenetrate = true;
				// 设置缓存 存入点击单号
				this.resetSetItem("penetrateOrderId", orderId);
				// 与父级跨域通信 传递isPenetrate参数
				window.parent.postMessage({
					//向窗口发送MessageEvent消息
					cmd: "returnFormJson",
					params: {
						isPenetrate
					}, //参数
				},
					"*"
				);
			}
		},
		//检索带回数据
		changeInputModel(val) {
			if (val != "" || val != undefined) {
				this.DialogVisible = false;
				this.paramValue(val);
			}
		},
		// 赋值字段
		paramValue(val) {
			let arr = this.sField.split(",");
			arr.forEach((item) => {
				this.getRequestData[item] = val[item];
			});
		},
		getSeWidth(e) {
			console.log(e);
			this.seWidth = e + "%";
		},
		getWidth(e) {
			console.log(e);
			this.exWidth = e + "%";
		},
		getSearchName(e) {
			console.log(e);
			this.seTitle = e;
		},
		getExtractName(e) {
			console.log(e);
			this.exTitle = e;
		},
		// 检索Id, 索引(表格中), 标识
		openSearch(sId, index, type, sField) {
			this.DialogVisible = true;
			this.seId = sId;
			this.sField = sField;
			this.parentSearchData[type] = this.getRequestData[type];
		},
		isShowData(name, value) {
			switch (name) {
				case "supplier":
					var dataInfo = sessionStorage.getItem("selectSupplierData");
					if (dataInfo) {
						dataInfo = JSON.parse(dataInfo);
						this.getRequestData.psomBuycus = dataInfo.smId;
						this.getRequestData.smName = dataInfo.smName;
					}
					break;
			}
		},

		// 获取数据列表
		async getPageInfo() {
			var pathId = parent.getMenuInfo(this.$route.path);
			let responseData = await this.$http.getJur({
				ids: [pathId.jurId]
			});
			if (responseData.status == 200) {
				this.pageShowData = responseData.result;
				this.formDataList = this.pageShowData.jurFormVoList;
				this.getDataList();
				this.getButtonList();
			} else {
				this.$message({
					message: responseData.message,
					type: "error",
				});
			}
		},
		async feeSettle() {
			let params = {
				ownerManageExpVoList: this.multipleSelection
			}
			let responseData = await this.$http.manageSettle(
				params
			);
			if (responseData && responseData.status == 200) {
				this.getDataList()
				this.$message({
					message: responseData.message,
					type: "success",
				});
			} else {
				this.$message({
					message: responseData.message,
					type: "error",
				});
			}
		},
		// 动作集合
		actionSet(actionData) {
			switch (actionData.actionType) {
				case 0:
					if (this.checkSelect()) {
						this.$confirm('确定结算费用？', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.feeSettle()
						}).catch(() => {

						});
					}
					break;
				case 1:
					if (this.checkSelect()) {
						if (this.multipleSelection.length > 1) {
							return this.$message({
								message: '请选中一条数据修改',
								type: 'error'
							});
						}
						var dataInfo = JSON.parse(JSON.stringify(this.multipleSelection[0]))
						this.selectInfo = dataInfo
						this.money = dataInfo.settleTotalManageExp
						this.diaChangeMoney = true
					}
					break;
				case 2:
					if (this.checkSelect()) {
						if (this.multipleSelection.length > 1) {
							return this.$message({
								message: '请选中一条数据修改',
								type: 'error'
							});
						}
						var dataInfo = JSON.parse(JSON.stringify(this.multipleSelection[0]))
						this.selectInfo = dataInfo
						this.lookMx()
					}
					break;
			}
		},
		async lookMx() {
			this.getRequestData1.coId = this.selectInfo.coId
			this.getRequestData1.yearMonths = this.selectInfo.yearMonths
			let responseData = await this.$http.queryManageListDetail(
				this.getRequestData1
			);
			if (responseData && responseData.status == 200) {
				this.diaLookMx = true
				this.mxData = responseData.result.list
				this.returnData1.pages = responseData.result.pages;
				this.returnData1.total = responseData.result.total;
				this.returnData1.pageNum = responseData.result.pageNum;
			} else {
				this.$message({
					message: responseData.message,
					type: "error",
				});
			}
		},
		openFormDesign() {
			let pathInfo = parent.getMenuInfo(this.$route.path)
			this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
		},
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1;
			this.getDataList();
		},
		// 数据翻页
		setDataPageNumber(val) {
			this.getRequestData.page = val;
			this.getDataList();
		},
		// 数据翻页
		setDataPageNumber1(val) {
			this.getRequestData1.page = val;
			this.lookMx();
		},

		// 切换显示条数
		setDataPageSize(val) {
			this.getRequestData.page = 1;
			this.getRequestData.rows = val;
			this.getDataList();
		},
		// 切换显示条数
		setDataPageSize1(val) {
			this.getRequestData1.page = 1;
			this.getRequestData1.rows = val;
			this.lookMx();
		},

		// 获取数据列表
		async getDataList() {
			let responseData = await this.$http.queryManageList(
				this.getRequestData
			);
			if (responseData && responseData.status == 200) {
				let resData = JSON.parse(JSON.stringify(responseData));
				this.returnData.list = resData.result.list;
				this.returnData.pages = resData.result.pages;
				this.returnData.total = resData.result.total;
				this.returnData.pageNum = resData.result.pageNum;
				this.selectedDataIndex = 0;
			} else {
				this.$message({
					message: responseData.message,
					type: "error",
				});
			}
		},
		// 删除数据
		delDataAction() {
			var dataInfo = this.returnData.list[this.selectedDataIndex];
			if (!dataInfo) {
				this.$message({
					message: "请先选中要操作的数据",
					type: "error",
				});
				return false;
			}

			this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(async () => {
					var delData = {
						ids: [dataInfo.ofrId],
					}
					let responseData = await this.$http.deleteOwnerfree(delData);
					if (responseData.status == 200) {
						this.$message({
							type: "success",
							message: "删除成功!",
						});

						this.getDataList();
					} else {
						this.$message({
							message: responseData.message,
							type: "error",
						});
					}
				})
				.catch(() => { });
		},
		// 获取按钮权限
		async getButtonList() {
			this.buttonList = await this.$common.getActionButton()
			
		},
async queryCate() {
			var responseData = await this.$http.queryCate();
			if (responseData.status == 200) {
				this.cateList = responseData.result
			} else {
				this.$message({
					message: '获取登记项目异常',
					type: "error",
				});
			}
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getPageInfo();
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
 },
	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() { }, //生命周期 - 更新之前
	updated() {this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
	beforeDestroy() { }, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
	margin-right: 1rem;
}

.el-tabs--border-card_new {
	height: 85vh;
	overflow-y: scroll;
}

.el-drawer {
	outline: none;
}
</style>